<template>
  <div class="folder-layout">
    <folder-sidebar v-if="!globalSearch && !hideFolderSidebar" />
    <user-toolbar />
    <v-content class="white">
        <router-view v-if="!globalSearch"/>
      <v-scroll-y-reverse-transition>
        <list-all-folders v-if="globalSearch" column/>
      </v-scroll-y-reverse-transition>
    </v-content>
    <form-new-folder />
    <loader-dialog :showLoader="loading.show" message="Carregando processos..." />
    <folder-created-dialog
      :isFolderCreatedDialogOpen="isFolderCreatedDialogOpen"
      :folderCreated="folderCreated"
      @toggleFolderCreatedDialog="toggleFolderCreatedDialog"
    />
  </div>
</template>

<script>
import LoaderDialog from '@/components/LoaderDialog'; // TODO: mover para 'components/base'
import UserToolbar from '@/components/user-toolbar/UserToolbar'; // TODO: mover para 'components/base'
import FolderSidebar from '@/components/folder/list/FolderSidebar';
import FormNewFolder from '@/components/folder/new/FormNewFolder';
import FolderCreatedDialog from '@/components/folder/new/FolderCreatedDialog';
import bus from '@/utils/event-bus';
import ListAllFolders from '@/components/base/ListAllFolders';

export default {
  name: 'folders-layout',
  components: {
    ListAllFolders,
    FolderSidebar,
    FormNewFolder,
    FolderCreatedDialog,
    LoaderDialog,
    UserToolbar,
  },
  mounted() {
    this.$store.dispatch('getUser')
    .then(() => {
      // Carregando contagem inicial de pastas
      this.loadFoldersCount();
    });
    bus.$on('folderCreated', (val) => {
      this.isFolderCreatedDialogOpen = val.showDialog;
      this.folderCreated = val.folder;
    });

    // Centraliza a atualização da contagem de pastas a cada 5 minutos
    this.startFoldersCountInterval();
  },
  beforeDestroy() {
    // Limpa o intervalo para evitar memory leak
    this.clearFoldersCountInterval();
  },
  data() {
    return {
      isFolderCreatedDialogOpen: false,
      folderCreated: {},
      countInterval: null,
    };
  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    },
    globalSearch() {
      return this.$store.getters.globalSearch;
    },
    hideFolderSidebar() {
      return this.$store.getters.hideFolderSidebar;
    },
  },
  methods: {
    toggleFolderCreatedDialog(val) {
      this.isFolderCreatedDialogOpen = val.showDialog;
    },
    loadFoldersCount(forceUpdate = false) {
      // Flag para controlar se a contagem já está sendo carregada
      if (this.$store.getters.isFoldersCountLoading) {
        return;
      }
      this.$store.dispatch('getFoldersCount', { forceUpdate });
    },
    startFoldersCountInterval() {
      // Atualiza a contagem de pastas a cada 5 minutos
      this.countInterval = setInterval(() => {
        this.loadFoldersCount();
      }, 5 * 60 * 1000);
    },
    clearFoldersCountInterval() {
      if (this.countInterval) {
        clearInterval(this.countInterval);
      }
    },
  },
};
</script>

<style lang="scss">
.folder-layout {
  background: #fff;

  .user-card {
    width: 100%;
    height: 100%;
    background: transparent;
    & {
      line-height: 1;
    }
    .v-list__tile {
      max-height: 38px;
    }
    .v-list__tile__avatar {
      min-width: 40px;
    }
  }

  .folder-list {
    &:last-child {
      margin-bottom: 48px;
    }
    .item {
      & {
        margin-left: 3px;
        position: relative;
        border-bottom: 1px solid rgba(0,0,0,.12);
        transition: ease-in-out .15s;
      }

      &:last-child {
        border-bottom: none;
      }

      &:hover {
        & {
          z-index: 1;
          cursor: pointer;
          box-shadow: 0 0 15px 5px rgba(0,0,0,.05);
        }

        .folder-border {
          width: 6px;
          left: -3px;
          border-radius: 6px 0 0 6px;
        }
      }
    }
    .folder-border {
      position: absolute;
      top: 0;
      left: -3px;
      width: 4px;
      height: 100%;
      border-radius: 3px 0 0 3px;
      background: #e0e0e0;
      transition: ease-in-out .15s;
    }
    .folder-icon {
      max-width: 32px;
    }
    .entity-chip {
      // Force width to entity chip with .text-truncate class in name
      &,
      >.v-chip__content {
        max-width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/FoldersLayout.vue